<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <div class="mainBody">
            <div class="searchBox">
                <div class="searchGroup">
                        <label>选择日期：</label>
                        <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="dateRangeSet"
                            style="width:420px">
                        </el-date-picker>
                    </div>
                <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                <el-button type="primary"  @click="exportLog">导出</el-button>
            </div>
            <div class="dataBox">
                <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                    <el-table-column prop="date" label="日期" sortable="custom" width="120"></el-table-column>
                    <el-table-column prop="username" label="用户名" sortable="custom" width="120"></el-table-column>
                    <el-table-column prop="realname" label="姓名" sortable="custom" width="120"></el-table-column>
                    <el-table-column prop="online_time_str" label="在线时长" sortable="custom"></el-table-column>
                    <el-table-column prop="ocr_count" label="OCR识别数量" sortable="custom"></el-table-column>
                    <el-table-column prop="import_report_count" label="导入报告数量" sortable="custom"></el-table-column>
                    <el-table-column prop="deal_report_check_count" label="处置监测报告数量" sortable="custom"></el-table-column>
                    <el-table-column prop="deal_report_extract_count" label="处置抽检报告数量" sortable="custom"></el-table-column>
                    <el-table-column prop="check_device_count" label="巡检设备数量" sortable="custom"></el-table-column>
                </el-table>
            </div>
            <div class="pageBox">
                <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import listutil from "@/libs/listutil"
import { exportUserMonitorLog } from '@/api/usermonitor'

export default {
    name: 'userMonitorLogList',
    mixins: [listutil],
    props: {
        user_id: {
            type: Number,
            default() {
                return 0;
            }
        },
        isshow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        title: {
            type: String,
            default() {
                return ""
            }
        },
        width: {
            type: String,
            default() {
                return '800px';
            }
        }
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            this.search_Obj.f_user_id = this.user_id;
            this.getData()
        },
    },
    data() {
        return {
            m_name: '人员工作监控',
            list_url: "/api/admin/usermonitorlog/list",
            search_Obj: {
                f_date: '',
                f_user_id: '',
                f_add_time_s_date: '',
                f_add_time_e_date: ''
            },
            del_Obj:{
                url:'/api/admin/usermonitor/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
            showflag: false,
            dateRange: [],
        };
    },
    methods: {
        closeDialog() {
            this.$emit("on-close")
        },
        exportLog(){
            exportUserMonitorLog(this.search_Obj.f_user_id, this.search_Obj.f_add_time_s_date, this.search_Obj.f_add_time_e_date).then(res=>{
                if(res.code == 1){
                    window.open(res.data)
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        dateRangeSet(val){
            if(this.$isNotNull(val)){
                this.search_Obj.f_add_time_s_date = val[0]
                this.search_Obj.f_add_time_e_date = val[1]
            }else{
                this.search_Obj.f_add_time_s_date = ''
                this.search_Obj.f_add_time_e_date = ''
            }
        },
    }
};
</script>